import { createSlice } from "@reduxjs/toolkit";
import {
  fetchOnboardedUsers,
  verifyUser,
  rejectUser,
  fetchAllUsers,
  deleteUser,
  fetchMyTasks,
  getProfile,
  editProfile,
} from "../thunks/userThunks";

const userSlice = createSlice({
  name: "user",
  initialState: {
    onboardedUsers: {
      users: [],
      loading: false,
      error: null,
    },
    staffProfile: {
      profile: {},
    },
    allUsers: {
      users: [],
      pagination: {},
      loading: false,
      error: null,
    },
    myTasks: {
      tasks: [],
      pagination: {},
      loading: false,
      error: null,
    },
  },
  extraReducers: (builder) => {
    //! order management
    // ------------------- ADMIN ONBOARDED USERS -------------------
    builder
      .addCase(fetchOnboardedUsers.pending, (state) => {
        state.onboardedUsers.loading = true;
        state.onboardedUsers.error = null;
      })
      .addCase(fetchOnboardedUsers.fulfilled, (state, action) => {
        state.onboardedUsers.loading = false;
        state.onboardedUsers.users = action.payload?.users || [];
      })
      .addCase(fetchOnboardedUsers.rejected, (state, action) => {
        state.onboardedUsers.loading = false;
        state.onboardedUsers.error = action.payload || [];
      });

    // Admin / Staff Profile
    builder
      .addCase(getProfile.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.staffProfile.profile = action.payload.data.user;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.payload || "Failed to fetch profile";
      });

    // VERIFY USER
    builder
      .addCase(verifyUser.pending, (state) => {
        // Optional: add loading state for verification
      })
      .addCase(verifyUser.fulfilled, (state, action) => {
        // Remove the verified user from pending users list
        state.onboardedUsers.users = state.onboardedUsers.users.filter(
          (user) => user._id !== action.payload.userId
        );

        // Optional: Add to allUsers if it's loaded
        if (action.payload.user && state.allUsers.users.length > 0) {
          state.allUsers.users.unshift(action.payload.user);
        }
      })
      .addCase(verifyUser.rejected, (state, action) => {
        state.onboardedUsers.error = action.payload || "Failed to verify user";
      });

    // REJECT USER
    builder
      .addCase(rejectUser.pending, (state) => {
        // Optional: add loading state for rejection
      })
      .addCase(rejectUser.fulfilled, (state, action) => {
        // Remove the rejected user from pending users list
        state.onboardedUsers.users = state.onboardedUsers.users.filter(
          (user) => user._id !== action.payload
        );
      })
      .addCase(rejectUser.rejected, (state, action) => {
        state.onboardedUsers.error = action.payload || "Failed to reject user";
      });

    // ------------------- ADMIN ALL USERS (VERIFIED) -------------------
    builder
      .addCase(fetchAllUsers.pending, (state) => {
        state.allUsers.loading = true;
        state.allUsers.error = null;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.allUsers.loading = false;
        state.allUsers.users = action.payload.users || [];
        state.allUsers.pagination = action.payload.pagination || {};
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.allUsers.loading = false;
        state.allUsers.error = action.payload || "Failed to fetch users";
      });

    // DELETE VERIFIED USER
    builder
      .addCase(deleteUser.pending, (state) => {
        // Optional: add loading state for deletion
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        // Remove the deleted user from verified users list
        state.allUsers.users = state.allUsers.users.filter(
          (user) => user._id !== action.payload
        );
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.allUsers.error = action.payload || "Failed to delete user";
      });

    // Fetch My Tasks
    builder
      .addCase(fetchMyTasks.pending, (state) => {
        state.myTasks.loading = true;
        state.myTasks.error = null;
      })
      .addCase(fetchMyTasks.fulfilled, (state, action) => {
        state.myTasks.loading = false;
        state.myTasks.tasks = action.payload.tasks || [];
        state.myTasks.pagination = action.payload.pagination || {};
      })
      .addCase(fetchMyTasks.rejected, (state, action) => {
        state.myTasks.loading = false;
        state.myTasks.error = action.payload || "Failed to fetch my tasks";
      });
  },
});
export default userSlice.reducer;
